import { useEffect } from "react";

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

export const usePageMeta = (title, description) => {
  useEffect(() => {
    const full = title ? `${title} | AVAILITY` : "AVAILITY | Professional Certification Platform";
    document.title = full;
    setMeta('meta[property="og:title"]', "property", "og:title", full);
    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
    }
  }, [title, description]);
};
